<template>
  <TDialog size="large">
    <template #title>title</template>
    <template #content>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br>content<br></template>
    <template #actions>actions</template>
  </TDialog>
</template>
<script setup lang="ts">
import { TDialog } from "@teachino/shared-design-system";
</script>
